module.exports = __webpack_public_path__ + "media/images/DataSource-8c5f0143564c5526fe95dbfd93492206.svg";